<template>
  <span :class="classes">
    <slot />
  </span>
</template>
<script setup lang="ts">
/* eslint no-unused-vars:off */
import { computed, PropType } from "vue";
import { BADGE_VARIANTS, VariantType } from "@/designSystem/Badge/constant";

const props = defineProps({
  variant: {
    type: String as PropType<VariantType>,
    default: BADGE_VARIANTS.light,
    validator: (value: string): value is VariantType => value in BADGE_VARIANTS,
  },
});

const classes = computed(() => ["badge", `badge-${props.variant}`]);
</script>

<style scoped lang="scss">
@import "@/designSystem/style/main.scss";
@import "@/designSystem/style/variables/_colors.scss";
@import "@/designSystem/style/variables/_font.scss";

@mixin badge-variant($color, $background) {
  color: $color;
  background-color: $background;

  i,
  svg,
  span {
    color: $color;
  }
}

.design-system:not(.legacy-design) {
  // Without this wrapper, bootstrap style is more specific than ours and it will override our styles
  // This avoids adding !important while bootstrap is still wrapped in .design-system:not(.legacy-design)
  .badge {
    &-success {
      @include badge-variant($primary, $primary-lighter);
    }

    &-warning {
      @include badge-variant($warning, $warning-lighter);
    }

    &-info {
      @include badge-variant($info-text, $info-darker);
    }

    &-danger {
      @include badge-variant($danger-dark, $danger-lighter);
    }

    &-light {
      @include badge-variant($gray-600, $light);
    }
  }
}
</style>
